import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';

/**
 * Owner/Admin only. Wraps `POST /time-off/activate` in a `useQuery` (not a
 * mutation) so it's cache-aware: repeated mounts of the gate within
 * `staleTime` reuse the cached result instead of re-issuing the call. The
 * backend call is idempotent either way, but there's no reason to hit it on
 * every page visit or route remount.
 */
export function useTimeOffActivationProbe(enabled: boolean) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TIME_OFF_KEYS.activationProbe(orgId),
    // `queryFn` can't resolve to `undefined` in TanStack Query v5 (it throws
    // "Query data cannot be undefined") — `activate()` returns `Promise<void>`,
    // so map its resolution to a real value.
    queryFn: () => timeOffService.activate().then(() => true),
    staleTime: 5 * 60_000,
    retry: false,
    enabled: !!orgId && enabled,
  });
}
